// extracted by mini-css-extract-plugin
module.exports = {"listC":"listC_listC__2dkN7"};